export default {"src":"/_next/static/media/Time.354dd1cb.svg","height":25,"width":25};